/**
 * Created by vladislav on 9/6/2022
 */

const G5Windows = function () {
    Microsoft.call(this, connector.G5WINDOWS);
};

G5Windows.prototype = Object.create(Microsoft.prototype);
G5Windows.prototype.constructor = G5Windows;

G5Windows.prototype.getAccessToken = function () {
    return "g5windows";
};

G5Windows.prototype.canReview = function () {
    return false;
};

G5Windows.prototype.isLatestVersionCheckSupported = function () {
    return false;
};

G5Windows.prototype._requestReview = function (callback) {
    callback(connector.CODE_FAILED);
};

G5Windows.prototype._initialize = function (callback) {
    document.addEventListener("keydown", (e) => {
        const key = e.key || "";
        if (key === "Enter" && e.altKey && !e.repeat) {
            this.toggleFullScreen();
        }
    }, false);

    connector.info.on("changeLanguage", (language) => {
        this.callNative("app.chooseLanguage", { language });
    });

    Microsoft.prototype._initialize.call(this, callback);
};

G5Windows.prototype.isFullscreenAvailable = function () {
    return true;
};

G5Windows.prototype.toggleFullScreen = function () {
    this.callNative("app.toggleFullScreen");
};

// inherits Microsoft, but no game has a cross-promo link for this source
G5Windows.prototype.canSwitchGame = function () {
    return false;
};
